/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ConnectBYOAzureBackupApplicationsRequest {
  /**
  * The object ID of the service principal for the keyvault access app. This corresponds to the output from the byo_backup_apps Terraform module. 
  */
  'keyVaultAccessServicePrincipalId': string;
  /**
  * The application ID of the management app registration. This corresponds to the output from the byo_backup_apps Terraform module. 
  */
  'managementAppId': string;
  /**
  * The object ID of the service principal for the management app. This corresponds to the output from the byo_backup_apps Terraform module. 
  */
  'managementServicePrincipalId': string;
  /**
  * The application ID of the backup app registration. This corresponds to the output from the byo_backup_apps Terraform module. 
  */
  'backupAppId': string;
  /**
  * The object ID of the service principal for the backup app. This corresponds to the output from the byo_backup_apps Terraform module. 
  */
  'backupServicePrincipalId': string;
  /**
  * The versionless URL of the secret stored in Key Vault for the management app. This corresponds to the versionless_id output from the byo_backup_apps Terraform module. 
  */
  'secretUrl': string;
  /**
  * The Azure tenant ID of the customer where the backup applications  will be registered. This identifies the customer\'s Azure AD tenant. 
  */
  'customerTenantId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "keyVaultAccessServicePrincipalId",
      "baseName": "keyVaultAccessServicePrincipalId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "managementAppId",
      "baseName": "managementAppId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "managementServicePrincipalId",
      "baseName": "managementServicePrincipalId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "backupAppId",
      "baseName": "backupAppId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "backupServicePrincipalId",
      "baseName": "backupServicePrincipalId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "secretUrl",
      "baseName": "secretUrl",
      "type": "string",
      "format": ""
    },
    {
      "name": "customerTenantId",
      "baseName": "customerTenantId",
      "type": "string",
      "format": "uuid"
    }  ];

  static getAttributeTypeMap() {
    return ConnectBYOAzureBackupApplicationsRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

